var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.name || _vm.$loading(_vm.name))?_c('div',{staticClass:"loading-indicator",class:{'overlay': _vm.overlay}},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }